module.exports = __webpack_public_path__ + "img/attestation.40c9b10a.png";